/**
 * Bandeau persistant affiché en haut de l'app quand l'utilisateur courant
 * est connecté via une session d'impersonation super-admin. Décode le
 * claim `imp` du JWT côté client. Bouton "Quitter" : purge le token +
 * redirige vers /login.
 */
import { useMemo } from "react";
import { getAccessToken, setAccessToken } from "../lib/api";

interface ImpClaim {
  by: string;
  byEmail: string;
}

function decodeImpClaim(token: string | null): ImpClaim | null {
  if (!token) return null;
  const parts = token.split(".");
  if (parts.length !== 3) return null;
  const payloadPart = parts[1];
  if (!payloadPart) return null;
  try {
    const payload = JSON.parse(
      atob(payloadPart.replace(/-/g, "+").replace(/_/g, "/")),
    );
    if (payload?.imp?.by && payload?.imp?.byEmail) {
      return payload.imp as ImpClaim;
    }
  } catch {
    return null;
  }
  return null;
}

export function ImpersonationBanner() {
  const imp = useMemo(() => decodeImpClaim(getAccessToken()), []);

  if (!imp) return null;

  const onExit = (): void => {
    setAccessToken(null);
    window.location.replace("/login");
  };

  return (
    <div className="sticky top-0 z-50 flex flex-wrap items-center justify-between gap-3 bg-amber-100 px-4 py-2 text-sm text-amber-900 ring-1 ring-amber-300">
      <p>
        <span className="font-bold uppercase tracking-wider">
          Mode impersonation
        </span>{" "}
        · session ouverte par <strong>{imp.byEmail}</strong> (super-admin
        Hubblot). Vos actions sont tracées dans l'audit du tenant.
      </p>
      <button
        type="button"
        onClick={onExit}
        className="rounded-md bg-amber-900 px-3 py-1 text-xs font-bold text-amber-50 hover:bg-amber-800"
      >
        Quitter la session
      </button>
    </div>
  );
}
